/*  Magic360-fix V6: Refactorizado y optimizado - SIN !important */

(function() {
    'use strict';
    
    // === VARIABLES GLOBALES ===
    var urls360 = [], magic360Block = null;
    var nombresGaleriaVarianteActiva = new Set();
    var interceptAttempts = 0;
    var interceptMaxAttempts = 40;
    var autoActivated360 = false;
    
    // === CSS sin !important - usando selectores muy específicos ===
    var style = document.createElement('style');
    style.id = 'magic360-fix-styles';
    style.textContent = [
        // Ocultar Magic360 original cuando está interceptado
        '#magic-360-block[data-interceptado="true"] {',
        '  position: fixed; top: -9999px; left: -9999px;',
        '  visibility: hidden; pointer-events: none;',
        '}',
        
        // Cuando está embebido en galería o modal
        '.magic360-gallery-container #magic-360-block,',
        '#magic360-zoom-wrapper #magic-360-block {',
        '  position: relative; top: auto; left: auto;',
        '  visibility: visible; pointer-events: auto;',
        '  display: block; width: 100%; height: 100%;',
        '}',
        
        // Contenedores internos de Magic360 visibles
        '.magic360-gallery-container .MagicToolboxContainer,',
        '.magic360-gallery-container .MagicToolboxSlides,',
        '.magic360-gallery-container .MagicToolboxSlide[data-slide-id="spin"],',
        '.magic360-gallery-container .Magic360-container,',
        '#magic360-zoom-wrapper .MagicToolboxContainer,',
        '#magic360-zoom-wrapper .MagicToolboxSlides,',
        '#magic360-zoom-wrapper .MagicToolboxSlide[data-slide-id="spin"],',
        '#magic360-zoom-wrapper .Magic360-container {',
        '  display: block; visibility: visible; position: relative;',
        '  width: 100%; height: 100%;',
        '}',
        
        // Max-width para canvas
        '#magic360-zoom-wrapper .Magic360-container,',
        '.magic360-gallery-container .Magic360-container {',
        '  max-width: 100%;',
        '}',
        
        // Ocultar elementos de UI de Magic360 que no queremos
        '#magic-360-block .MagicToolboxSelectorsContainer,',
        '#magic-360-block .MagicToolboxSlides-arrow,',
        '#magic-360-block .MagicToolboxSlide:not([data-slide-id="spin"]) {',
        '  display: none; visibility: hidden; pointer-events: none;',
        '}',
        
        // Ocultar slides/thumbs de imágenes 360
        '[data-hidden-by-magic360="true"] {',
        '  display: none;',
        '}',
        
        // Contenedor en galería
        '.magic360-gallery-container {',
        '  position: relative; width: 100%; height: 100%;',
        '  display: flex; align-items: center; justify-content: center;',
        '  cursor: grab; transition: opacity 0.15s ease-out;',
        '}',
        '.magic360-gallery-container.transitioning { opacity: 0.7; }',
        
        // Botón de zoom
        'button.magic360-zoom-btn {',
        '  position: absolute; top: 12px; right: 12px;',
        '  background: rgba(0,0,0,0.7); color: white;',
        '  border: none; padding: 10px; border-radius: 50%;',
        '  cursor: pointer; z-index: 15;',
        '  display: flex; align-items: center; justify-content: center;',
        '  transition: background 0.2s, transform 0.2s;',
        '}',
        'button.magic360-zoom-btn:hover {',
        '  background: rgba(0,0,0,0.9); transform: scale(1.1);',
        '}',
        
        // Wrapper en modal de zoom
        '#magic360-zoom-wrapper {',
        '  position: absolute; top: 0; left: 0;',
        '  width: 100%; height: 100%; z-index: 5;',
        '  display: flex; align-items: center; justify-content: center;',
        '  background: #fff; pointer-events: auto;',
        '  transition: opacity 0.15s ease-out;',
        '}',
        
        // Badge 360° en thumbnails
        '.magic360-thumb-badge {',
        '  position: absolute; bottom: 4px; right: 4px;',
        '  background: rgba(0,0,0,0.85); color: white;',
        '  padding: 2px 5px; border-radius: 3px;',
        '  font-size: 9px; font-weight: 600; line-height: 1;',
        '}',
        '.gallery-zoom__thumb .magic360-thumb-badge {',
        '  bottom: 3px; right: 3px; padding: 2px 4px; font-size: 8px;',
        '}',
        
        // Anti-parpadeo
        '#magic-360-block, .MagicToolboxContainer,',
        '.MagicToolboxSlides, .Magic360-container {',
        '  backface-visibility: hidden;',
        '}'
    ].join('\n');
    document.head.appendChild(style);
    
    // === INICIALIZACIÓN ===
    init();
    
    function init() {
        scheduleIntercept(0);
        bindVariantChangeRecovery();
        
        // Interceptar GalleryZoom a nivel de prototipo para capturar TODOS los selectThumb
        interceptarGalleryZoomPrototype();
        
        // Observer para carga tardía
        var observer = new MutationObserver(function() {
            var block = document.getElementById('magic-360-block');
            if (block && !block.dataset.interceptado) scheduleIntercept(100);
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
        setTimeout(function() { observer.disconnect(); }, 10000);
    }

    function bindVariantChangeRecovery() {
        if (window.__magic360VariantRecoveryBound) return;
        window.__magic360VariantRecoveryBound = true;

        document.addEventListener('change', function(e) {
            var target = e && e.target;
            if (!target) return;

            var isVariantInput =
                target.matches('input[name^="upng-variant-option"]') ||
                target.matches('input[name="id"]');

            if (!isVariantInput) return;

            autoActivated360 = false;
            nombresGaleriaVarianteActiva = obtenerNombresGaleriaVarianteActiva();

            var block = document.getElementById('magic-360-block') || magic360Block;
            if (block && block.hasAttribute('data-interceptado')) {
                block.removeAttribute('data-interceptado');
            }

            // Esperar a que el tema reconstruya la galería y reinterceptar.
            scheduleIntercept(120);
            scheduleIntercept(320);
        }, true);
    }

    function scheduleIntercept(delay) {
        if (interceptAttempts >= interceptMaxAttempts) return;
        setTimeout(function() {
            interceptAttempts++;
            interceptarMagic360();
        }, delay || 0);
    }

    function magic360Listo(block) {
        if (!block) return false;
        if (!window.Magic360) return false;
        if (block.querySelector('.Magic360-container')) return true;
        if (block.querySelector('canvas')) return true;
        if (block.querySelector('a.Magic360, a[data-magic360-options]')) return true;
        return false;
    }
    
    function interceptarGalleryZoomPrototype() {
        // Esperar a que GalleryZoom esté definido
        var checkInterval = setInterval(function() {
            var GalleryZoom = window.customElements?.get('gallery-zoom');
            if (GalleryZoom && GalleryZoom.prototype && !GalleryZoom.prototype._magic360Intercepted) {
                GalleryZoom.prototype._magic360Intercepted = true;
                
                var origSelectThumb = GalleryZoom.prototype.selectThumb;
                GalleryZoom.prototype.selectThumb = function(thumb) {
                    // Si es thumb 360, manejar especialmente
                    if (thumb && thumb.dataset && thumb.dataset.is360 === 'true') {
                        var modal = this.closest('.gallery-zoom-modal');
                        if (modal) {
                            mostrar360EnModal(modal, thumb);
                            return;
                        }
                    }
                    
                    // Si había 360 activo, ocultarlo primero
                    var modal = this.closest('.gallery-zoom-modal');
                    if (modal && this.dataset.magic360Active === 'true') {
                        ocultarMagic360EnModal(modal);
                    }
                    
                    // Llamar al original
                    return origSelectThumb.call(this, thumb);
                };

                var origInit = GalleryZoom.prototype.init;
                GalleryZoom.prototype.init = function(currentMediaId) {
                    var res = origInit.call(this, currentMediaId);
                    if (!urls360 || urls360.length === 0) return res;
                    var modal = this.closest('.gallery-zoom-modal');
                    if (modal) {
                        prepararGalleryZoom(modal);
                        limpiarModalZoom(modal, crearSetNombres(urls360));
                        agregarThumb360AlModal(modal);
                    }
                    return res;
                };
                
                clearInterval(checkInterval);
            }
        }, 100);
        
        // Timeout de seguridad
        setTimeout(function() { clearInterval(checkInterval); }, 10000);
    }

    // === INTERCEPTAR MAGIC360 ===
    function interceptarMagic360() {
        var magicBlock = document.getElementById('magic-360-block') || magic360Block;
        var mediaViewerUl = document.querySelector('.media-viewer');
        var mediaThumbsUl = document.querySelector('.media-thumbs');
        
        if (!magicBlock || !mediaViewerUl) return;
        if (magicBlock.dataset.interceptado === 'true' && mediaViewerUl.querySelector('[data-media-id="magic-360-preview"]')) return;
        if (!magic360Listo(magicBlock)) {
            scheduleIntercept(250);
            return;
        }
        
        // Extraer URLs
        urls360 = extraerUrls(magicBlock);
        if (urls360.length === 0) {
            scheduleIntercept(350);
            return;
        }

        nombresGaleriaVarianteActiva = obtenerNombresGaleriaVarianteActiva();

        magicBlock.dataset.interceptado = 'true';
        magic360Block = magicBlock;
        
        var nombres360 = crearSetNombres(urls360);
        
        // Restaurar galería nativa si fue ocultada
        restaurarGaleria(mediaViewerUl);
        
        // Ocultar elementos 360° duplicados
        ocultarElementos360(mediaThumbsUl, mediaViewerUl, nombres360);
        
        // Crear slide y thumbnail del 360°
        var slide360 = crearSlide360(mediaViewerUl, mediaThumbsUl);

        // Auto-activar el 360 al cargar si está listo
        if (slide360) activar360SiDisponible(slide360);
        
        // Configurar limpieza en modal de zoom
        observarModalZoom(nombres360);
    }

    // === UTILIDADES ===
    function extraerUrls(block) {
        if (window.m360ImagesSmall?.length > 0) return window.m360ImagesSmall;
        
        var link = block.querySelector('a.Magic360, a[data-magic360-options]');
        if (!link) return [];
        
        var data = link.getAttribute('data-magic360-options') || '';
        var match = data.match(/images:\s*([^;]+)(?:;|$)/i);
        var source = match ? match[1] : data;
        var urls = source.match(/((?:https?:)?\/\/[^\s,;]+?\.(?:jpg|jpeg|png|webp)(?:\?[^\s,;]*)?)/gi);
        return (urls || []).map(function(u) { return u.startsWith('//') ? 'https:' + u : u; });
    }
    
    function crearSetNombres(urls) {
        var set = new Set();
        urls.forEach(function(url) {
            var nombre = normalizarNombre(url);
            if (nombre) set.add(nombre);
        });
        return set;
    }
    
    function normalizarNombre(src) {
        if (!src) return '';
        return src.split('?')[0].split('/').pop()
            .replace(/\.(jpg|jpeg|png|webp|gif)$/i, '')
            .replace(/_\d+x\d*$|_\d+x$/, '')
            .replace(/_grande$|_large$|_medium$|_small$|_thumb$|_compact$|_master$/i, '')
            .toLowerCase();
    }
    
    function esImagen360(src, nombres) {
        return nombres.has(normalizarNombre(src));
    }

    function normalizarUrl(url) {
        if (!url || typeof url !== 'string') return '';
        var limpia = url.trim();
        if (!limpia) return '';
        if (limpia.indexOf('//') === 0) limpia = 'https:' + limpia;
        return limpia;
    }

    function extraerUrlDeItemGaleria(item) {
        if (!item) return '';
        if (typeof item === 'string') return normalizarUrl(item);
        if (typeof item !== 'object') return '';
        if (item.src) return normalizarUrl(item.src);
        if (item.url) return normalizarUrl(item.url);
        if (item.image && item.image.src) return normalizarUrl(item.image.src);
        if (item.preview_image && item.preview_image.src) return normalizarUrl(item.preview_image.src);
        return '';
    }

    function obtenerNombresGaleriaVarianteActiva() {
        var set = new Set();
        var input = document.querySelector('input[name^="upng-variant-option"]:checked') ||
                    document.querySelector('input[name^="upng-variant-option"]');
        if (!input || !input.dataset || !input.dataset.galleryImages) return set;
        if (input.dataset.hasVariantGallery !== 'true') return set;

        try {
            var data = JSON.parse(input.dataset.galleryImages);
            if (!Array.isArray(data)) return set;
            data.forEach(function(item) {
                var url = extraerUrlDeItemGaleria(item);
                var nombre = normalizarNombre(url);
                if (nombre) set.add(nombre);
            });
        } catch (e) {}

        return set;
    }

    function esImagenGaleriaVarianteActiva(src) {
        if (!nombresGaleriaVarianteActiva || nombresGaleriaVarianteActiva.size === 0) return false;
        return nombresGaleriaVarianteActiva.has(normalizarNombre(src));
    }
    
    function restaurarGaleria(viewer) {
        var el = viewer;
        for (var i = 0; i < 8 && el; i++) {
            var st = getComputedStyle(el);
            if (st.top === '-10000px' || st.visibility === 'hidden' || st.display === 'none') {
                el.style.cssText = 'position:static;visibility:visible;opacity:1;display:block;width:100%;height:auto;top:auto;left:auto;';
            }
            el = el.parentElement;
        }
    }
    
    function ocultarElementos360(thumbsUl, viewerUl, nombres) {
        // Thumbs
        if (thumbsUl) {
            thumbsUl.querySelectorAll('.media-thumbs__item').forEach(function(item) {
                var img = item.querySelector('img');
                if (!img) return;
                if (esImagenGaleriaVarianteActiva(img.src)) {
                    item.removeAttribute('data-hidden-by-magic360');
                    return;
                }
                if (esImagen360(img.src, nombres)) {
                    item.setAttribute('data-hidden-by-magic360', 'true');
                }
            });
        }
        
        // Slides
        viewerUl.querySelectorAll('.media-viewer__item').forEach(function(slide) {
            var img = slide.querySelector('img');
            if (!img) return;
            if (esImagenGaleriaVarianteActiva(img.src)) {
                slide.removeAttribute('data-hidden-by-magic360');
                return;
            }
            if (esImagen360(img.src, nombres)) {
                slide.setAttribute('data-hidden-by-magic360', 'true');
            }
        });
    }
    
    function observarModalZoom(nombres) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                m.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 && node.classList?.contains('gallery-zoom-modal')) {
                        // Preparar gallery-zoom PRIMERO, antes de agregar thumbs
                        prepararGalleryZoom(node);
                        limpiarModalZoom(node, nombres);
                        agregarThumb360AlModal(node);
                    }
                });
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
    
    function prepararGalleryZoom(modal) {
        var galleryZoom = modal.querySelector('gallery-zoom');
        if (!galleryZoom || galleryZoom._magic360Prepared) return;
        
        galleryZoom._magic360Prepared = true;
        
        // Guardar métodos originales de esta instancia
        galleryZoom._origMethods = {
            panZoomImageFromCoordinate: galleryZoom.panZoomImageFromCoordinate,
            trackInputMovement: galleryZoom.trackInputMovement,
            alterCurrentTransformZoomBy: galleryZoom.alterCurrentTransformZoomBy,
            onZoomContainerClick: galleryZoom.onZoomContainerClick,
            alterCurrentPanBy: galleryZoom.alterCurrentPanBy,
            setInitialImagePosition: galleryZoom.setInitialImagePosition
        };
    }
    
    function limpiarModalZoom(modal, nombres) {
        modal.querySelectorAll('.gallery-zoom__thumb').forEach(function(thumb) {
            if (thumb.dataset.mediaId === 'magic-360-preview') return;
            var img = thumb.querySelector('img');
            if (!img) return;
            if (esImagenGaleriaVarianteActiva(img.src)) {
                thumb.removeAttribute('data-hidden-by-magic360');
                return;
            }
            if (esImagen360(img.src, nombres)) {
                thumb.setAttribute('data-hidden-by-magic360', 'true');
            }
        });
    }
    
    function refreshMagic360() {
        window.dispatchEvent(new Event('resize'));
        if (window.Magic360?.refresh) try { Magic360.refresh(); } catch(e) {}
    }

    // === CREAR SLIDE 360° ===
    function crearSlide360(viewerUl, thumbsUl) {
        var existing = viewerUl.querySelector('[data-media-id="magic-360-preview"]');
        if (existing) return existing;
        
        var mediaGallery = document.querySelector('media-gallery');
        
        // Slide principal
        var slide = document.createElement('li');
        slide.className = 'media-viewer__item snap-start';
        slide.dataset.type = 'magic-360';
        slide.dataset.mediaId = 'magic-360-preview';
        
        var wrapper = document.createElement('div');
        wrapper.className = 'media-viewer__media media relative';
        
        var container = document.createElement('div');
        container.className = 'magic360-gallery-container';
        
        var zoomBtn = document.createElement('button');
        zoomBtn.className = 'magic360-zoom-btn';
        zoomBtn.title = 'Abrir en pantalla completa';
        zoomBtn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';
        zoomBtn.onclick = function(e) { e.preventDefault(); e.stopPropagation(); abrirZoomConMagic360(); };
        
        wrapper.appendChild(container);
        wrapper.appendChild(zoomBtn);
        slide.appendChild(wrapper);
        viewerUl.insertBefore(slide, viewerUl.firstChild);
        
        // Embeber Magic360
        container.appendChild(magic360Block);
        setTimeout(refreshMagic360, 100);
        
        // Thumbnail
        if (thumbsUl) {
            var thumbItem = document.createElement('li');
            thumbItem.className = 'media-thumbs__item';
            thumbItem.dataset.mediaId = 'magic-360-preview';
            
            var thumbBtn = document.createElement('button');
            thumbBtn.className = 'media-thumbs__btn media w-full relative';
            thumbBtn.style.paddingTop = '100%';
            
            var thumbImg = document.createElement('img');
            thumbImg.src = urls360[0];
            thumbImg.alt = 'Vista 360°';
            thumbImg.className = 'img-fit img-fit--contain w-full';
            thumbImg.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;';
            
            var badge = document.createElement('div');
            badge.className = 'magic360-thumb-badge';
            badge.textContent = '360°';
            
            thumbBtn.appendChild(thumbImg);
            thumbBtn.appendChild(badge);
            thumbItem.appendChild(thumbBtn);
            thumbsUl.insertBefore(thumbItem, thumbsUl.firstChild);
            
            // Click handler
            thumbBtn.onclick = function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (mediaGallery?.customSetActiveMedia) {
                    mediaGallery.customSetActiveMedia(slide, true);
                }
            };
            
            // Actualizar visibleItems
            if (mediaGallery?.setVisibleItems) mediaGallery.setVisibleItems();
        }

        return slide;
    }

    function activar360SiDisponible(slide) {
        if (autoActivated360) return;
        var mediaGallery = document.querySelector('media-gallery');
        if (!mediaGallery?.customSetActiveMedia || !slide) return;
        if (!magic360Listo(magic360Block)) {
            setTimeout(function() { activar360SiDisponible(slide); }, 150);
            return;
        }
        autoActivated360 = true;
        mediaGallery.customSetActiveMedia(slide, true);
        sincronizarThumbActivo360();
        setTimeout(sincronizarThumbActivo360, 120);
        setTimeout(refreshMagic360, 100);
    }

    function sincronizarThumbActivo360() {
        var mediaGallery = document.querySelector('media-gallery');
        if (!mediaGallery) return;

        var slide360 = mediaGallery.querySelector('.media-viewer__item[data-media-id="magic-360-preview"]');
        var thumb360 = mediaGallery.querySelector('.media-thumbs__item[data-media-id="magic-360-preview"] .media-thumbs__btn');
        if (!slide360 || !thumb360) return;

        mediaGallery.querySelectorAll('.media-thumbs__btn').forEach(function(btn) {
            btn.classList.remove('is-active');
            btn.removeAttribute('aria-current');
        });
        thumb360.classList.add('is-active');
        thumb360.setAttribute('aria-current', 'true');

        mediaGallery.querySelectorAll('.media-viewer__item').forEach(function(item) {
            item.classList.remove('is-current-variant');
        });
        slide360.classList.add('is-current-variant');
    }

    // === MODAL DE ZOOM ===
    function abrirZoomConMagic360() {
        var mediaGallery = document.querySelector('media-gallery');
        var slide = document.querySelector('[data-media-id="magic-360-preview"]');
        
        if (!mediaGallery?.galleryModal || !slide) return;
        
        if (!mediaGallery.galleryModal.parentElement) {
            document.body.appendChild(mediaGallery.galleryModal);
        }
        
        if (mediaGallery.galleryModal.open) {
            mediaGallery.galleryModal.open(slide);
        }
        
        var tries = 0;
        var maxTries = 25;
        var tryClick = function() {
            tries++;
            var modal = document.querySelector('.gallery-zoom-modal');
            var thumb = modal?.querySelector('[data-media-id="magic-360-preview"]');
            if (thumb) {
                thumb.click();
                return;
            }
            if (tries < maxTries) setTimeout(tryClick, 120);
        };
        setTimeout(tryClick, 120);
    }
    
    function agregarThumb360AlModal(modal) {
        var container = modal.querySelector('.gallery-zoom__thumbs');
        if (!urls360 || !urls360[0]) return;
        if (!container || container.querySelector('[data-media-id="magic-360-preview"]')) return;
        
        var li = document.createElement('li');
        li.className = 'gallery-zoom__thumb slider__item flex';
        li.dataset.mediaId = 'magic-360-preview';
        li.dataset.is360 = 'true';
        // Usar primera imagen 360 como zoom-url para evitar error 404
        li.dataset.zoomUrl = urls360[0] || '';
        
        var btn = document.createElement('button');
        btn.className = 'media-thumbs__btn media w-full relative';
        btn.style.paddingTop = '100%';
        
        var img = document.createElement('img');
        img.src = urls360[0];
        img.alt = 'Vista 360°';
        img.className = 'gallery-zoom__thumb-img img-fit img-fit--contain w-full';
        img.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;';
        
        var badge = document.createElement('div');
        badge.className = 'magic360-thumb-badge';
        badge.textContent = '360°';
        
        btn.appendChild(img);
        btn.appendChild(badge);
        li.appendChild(btn);
        container.insertBefore(li, container.firstChild);
        
        li.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            mostrar360EnModal(modal, li);
        };
    }
    
    function ocultarMagic360EnModal(modal) {
        var wrapper = modal.querySelector('#magic360-zoom-wrapper');
        
        // Devolver Magic360 a la galería
        var container = document.querySelector('.magic360-gallery-container');
        if (magic360Block && container) {
            container.appendChild(magic360Block);
            setTimeout(refreshMagic360, 100);
        }
        
        if (wrapper) wrapper.remove();
        
        // Restaurar métodos de gallery-zoom para zoom normal
        var gz = modal.querySelector('gallery-zoom');
        if (gz && gz._origMethods) {
            gz.panZoomImageFromCoordinate = gz._origMethods.panZoomImageFromCoordinate;
            gz.trackInputMovement = gz._origMethods.trackInputMovement;
            gz.alterCurrentTransformZoomBy = gz._origMethods.alterCurrentTransformZoomBy;
            gz.onZoomContainerClick = gz._origMethods.onZoomContainerClick;
            gz.alterCurrentPanBy = gz._origMethods.alterCurrentPanBy;
            gz.setInitialImagePosition = gz._origMethods.setInitialImagePosition;
            // NO restaurar selectThumb - lo mantenemos interceptado
            gz.dataset.magic360Active = 'false';
            
            // Resetear transform state para que la próxima imagen se posicione bien
            if (gz.currentTransform) {
                gz.currentTransform.zoom = 1;
                gz.currentTransform.panX = 0;
                gz.currentTransform.panY = 0;
            }
        }
    }
    
    function mostrar360EnModal(modal, thumbActivo) {
        var zoomContainer = modal.querySelector('.gallery-zoom__zoom-container');
        var galleryZoom = modal.querySelector('gallery-zoom');
        
        if (!zoomContainer || !magic360Block) return;
        if (!magic360Listo(magic360Block)) {
            setTimeout(function() { mostrar360EnModal(modal, thumbActivo); }, 150);
            return;
        }
        
        // Marcar thumbs
        modal.querySelectorAll('.gallery-zoom__thumb').forEach(function(t) {
            t.classList.remove('gallery-zoom__thumb--active');
        });
        if (thumbActivo) {
            thumbActivo.classList.add('gallery-zoom__thumb--active');
        }
        
        // Actualizar contador si existe
        var counterCurrent = modal.querySelector('.gallery-zoom__counter-current');
        if (counterCurrent) {
            counterCurrent.textContent = '1';
        }
        
        // Actualizar estado de botones prev/next
        var prevBtn = modal.querySelector('.gallery-zoom__btn--previous');
        var nextBtn = modal.querySelector('.gallery-zoom__btn--next');
        var thumbContainer = modal.querySelector('.gallery-zoom__thumbs');
        if (prevBtn && nextBtn && thumbContainer) {
            var visibleThumbs = Array.from(thumbContainer.children).filter(function(c) { return !c.hidden && c.offsetParent; });
            var activeIndex = visibleThumbs.indexOf(thumbActivo);
            prevBtn.disabled = activeIndex === 0;
            nextBtn.disabled = activeIndex === visibleThumbs.length - 1;
        }
        
        // Parchear métodos que causan errores con 360
        if (galleryZoom) {
            galleryZoom.dataset.magic360Active = 'true';
            
            var noop = function() {};
            galleryZoom.panZoomImageFromCoordinate = noop;
            galleryZoom.trackInputMovement = noop;
            galleryZoom.alterCurrentTransformZoomBy = noop;
            galleryZoom.onZoomContainerClick = noop;
            galleryZoom.alterCurrentPanBy = noop;
            galleryZoom.setInitialImagePosition = noop;
        }
        
        // Crear wrapper y mover Magic360
        var existingWrapper = modal.querySelector('#magic360-zoom-wrapper');
        if (existingWrapper) existingWrapper.remove();
        
        var wrapper = document.createElement('div');
        wrapper.id = 'magic360-zoom-wrapper';
        wrapper.appendChild(magic360Block);
        zoomContainer.appendChild(wrapper);
        
        // Ocultar imagen original del zoom si existe
        zoomContainer.querySelectorAll(':scope > img').forEach(function(img) {
            img.style.display = 'none';
        });
        
        // Quitar clase de loading
        zoomContainer.classList.remove('gallery-zoom__zoom-container--loading');
        
        setTimeout(refreshMagic360, 120);
        
        observarCierreModal(modal);
    }
    
    function observarCierreModal(modal) {
        // Evitar múltiples observers
        if (modal._magic360CloseObserverActive) return;
        modal._magic360CloseObserverActive = true;
        
        var modalDialog = modal.closest('modal-dialog') || modal;
        
        // Botones de cerrar
        modal.querySelectorAll('button[aria-label="Close"], .js-close-modal, [data-modal-close]').forEach(function(btn) {
            if (btn._magic360CloseHandler) return;
            btn._magic360CloseHandler = function() { 
                setTimeout(function() { restaurarAGaleria(); modal._magic360CloseObserverActive = false; }, 50); 
            };
            btn.addEventListener('click', btn._magic360CloseHandler);
        });
        
        // Escape key
        if (!modal._magic360EscHandler) {
            modal._magic360EscHandler = function(e) {
                if (e.key === 'Escape') {
                    setTimeout(function() { restaurarAGaleria(); modal._magic360CloseObserverActive = false; }, 50);
                }
            };
            document.addEventListener('keydown', modal._magic360EscHandler);
        }
        
        // Observer para atributo open
        if (!modal._magic360OpenObserver) {
            modal._magic360OpenObserver = new MutationObserver(function() {
                if (!modalDialog.hasAttribute('open')) {
                    restaurarAGaleria();
                    modal._magic360CloseObserverActive = false;
                }
            });
            modal._magic360OpenObserver.observe(modalDialog, { attributes: true, attributeFilter: ['open'] });
        }
    }
    
    function restaurarDesdeModal(modal) {
        ocultarMagic360EnModal(modal);
    }
    
    function restaurarAGaleria() {
        var container = document.querySelector('.magic360-gallery-container');
        if (magic360Block && container && !container.contains(magic360Block)) {
            container.appendChild(magic360Block);
            setTimeout(refreshMagic360, 150);
        }
        
        // Limpiar wrappers residuales
        document.querySelectorAll('#magic360-zoom-wrapper').forEach(function(w) { w.remove(); });
        
        // Restaurar gallery-zooms completamente
        document.querySelectorAll('gallery-zoom').forEach(function(gz) {
            if (gz._origMethods) {
                gz.panZoomImageFromCoordinate = gz._origMethods.panZoomImageFromCoordinate;
                gz.trackInputMovement = gz._origMethods.trackInputMovement;
                gz.alterCurrentTransformZoomBy = gz._origMethods.alterCurrentTransformZoomBy;
                gz.onZoomContainerClick = gz._origMethods.onZoomContainerClick;
                gz.alterCurrentPanBy = gz._origMethods.alterCurrentPanBy;
                gz.setInitialImagePosition = gz._origMethods.setInitialImagePosition;
            }
            gz.dataset.magic360Active = 'false';
            gz._magic360Prepared = false;
            
            // Resetear transform
            if (gz.currentTransform) {
                gz.currentTransform.zoom = 1;
                gz.currentTransform.panX = 0;
                gz.currentTransform.panY = 0;
            }
        });
        
        // Limpiar estilos residuales de imágenes
        document.querySelectorAll('.gallery-zoom__zoom-container > img').forEach(function(img) {
            img.style.display = '';
            img.style.transform = '';
            img.style.top = '';
            img.style.left = '';
        });
    }

})();
